import { combineLatest, Observable, of, ReplaySubject } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { TabState } from "~app/common/components/tabs/tab/itab";

export class TabStateHelper {
    readonly tabState$ = new ReplaySubject<TabState>(1);
    readonly effectivelyVisible$: Observable<boolean>;

    constructor(parent?: TabStateHelper) {
        this.effectivelyVisible$ = combineLatest([
            this.tabState$,
            parent?.effectivelyVisible$ ?? of(true)
        ]).pipe(
            map(([
                state,
                parentVisible
            ]) =>
                state === "active"
                && parentVisible),
            shareReplay()
        );
    }
}
